import React, { useEffect, useRef } from "react";
import axios from "axios";
import { ReactSession } from "react-client-session";
import { useLocation } from "react-router-dom";
import "./Login.css";
import { FcGoogle } from "react-icons/fc";
import { useState } from "react";
function Login(props) {
    ReactSession.setStoreType("localStorage");
    localStorage.clear();
    const location = useLocation();
    const [switchs, setSwitch] = useState(10);
    const [loginPhoneState, setLoginPhoneState] = useState(0);

    useEffect(() => {
        props.header.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (location.state) {
            setSwitch(location.state.switchs);
        }
    }, [location]);

    const sendLoginCode = () => {
        if (document.getElementById("loginPhone")) {
            var loginPhone = document.getElementById("loginPhone").value;
            if (loginPhone.slice(0, 2) == "98") {
                loginPhone = parseInt(loginPhone.substring(2));
            }
            var loginDialogOk = document.getElementById("labelLSGNDialogOk");
            var loginDialogErr = document.getElementById("labelLSGNDialogErr");
            if (loginPhone) {
                axios
                    .get("https://hammaskan.ir:8443/api/auths/login/code/" + loginPhone, {
                        params: {},
                    })
                    .then((res) => {
                        // console.log(res);
                        loginDialogErr.style.display = "none";
                        loginDialogOk.style.display = "inline-block";
                        setLoginPhoneState(loginPhone);
                        setTimeout(() => {
                            setSwitch(11);
                        }, 2000);
                    })
                    .catch((error) => {
                        // console.log(error);
                        loginDialogOk.style.display = "none";
                        loginDialogErr.style.display = "inline-block";
                        if (error.response.data.message) {
                            loginDialogErr.textContent = error.response.data.message;
                        } else {
                            loginDialogErr.textContent = "امکان ارسال پیامک وجود ندارد";
                        }
                    });
            } else {
                loginDialogOk.style.display = "none";
                loginDialogErr.style.display = "inline-block";
                loginDialogErr.textContent = "شماره تلفن خود را وارد نمایید";
            }
        }
    };
    const LoginCode = () => {
        console.log("ok");
        if (document.getElementById("loginCode")) {
            var loginCode = document.getElementById("loginCode").value;
            var loginDialogOk = document.getElementById("labelLSGNDialogOk");
            var loginDialogErr = document.getElementById("labelLSGNDialogErr");
            if (loginCode) {
                axios
                    .post("https://hammaskan.ir:8443/api/auths/login/code", {
                        code: loginCode,
                        phoneNumber: loginPhoneState,
                    })
                    .then((res) => {
                        loginDialogOk.style.display = "inline-block";
                        loginDialogErr.style.display = "none";
                        // console.log(res.data.data);
                        ReactSession.set("UserId", res.data.data.id);
                        ReactSession.set("UserfirstName", res.data.data.firstName);
                        ReactSession.set("UserLastName", res.data.data.lastName);
                        ReactSession.set("UserPhoneNumber", res.data.data.phoneNumber);
                        ReactSession.set("UserType", res.data.data.type);
                        ReactSession.set("UserEmail", res.data.data.email);
                        setTimeout(() => {
                            if (res.data.data.type == "normalUser") {
                                window.location.href = "./normal";
                            } else if (res.data.data.type == "producerUser") {
                                window.location.href = "./producer";
                            }
                        }, 2000);
                    })
                    .catch((error) => {
                        // console.log(error);
                        loginDialogOk.style.display = "none";
                        loginDialogErr.style.display = "inline-block";
                        if (error.response.data.message) {
                            loginDialogErr.textContent = error.response.data.message;
                        } else {
                            loginDialogErr.textContent = "کد وارد شده اشتباه است";
                        }
                    });
            } else {
                loginDialogErr.style.display = "inline-block";
                loginDialogErr.textContent = " کد ورود خود را وارد نمایید";
            }
        }
    };
    const LoginPass = () => {
        // console.log("ok");
        if (document.getElementById("loginPassPhone")) {
            var loginPassPhone = document.getElementById("loginPassPhone").value;
            var loginPassword = document.getElementById("loginPassword").value;
            var loginDialogPassOk = document.getElementById("labelLSGNDialogPassOk");
            var loginDialogPassErr = document.getElementById("labelLSGNDialogPassErr");
            if (loginPassPhone && loginPassword) {
                axios
                    .post("https://hammaskan.ir:8443/api/auths/pass", {
                        password: loginPassword,
                        phoneNumber: loginPassPhone,
                    })
                    .then((res) => {
                        loginDialogPassOk.style.display = "inline-block";
                        loginDialogPassErr.style.display = "none";
                        // console.log(res.data.data);
                        ReactSession.set("UserId", res.data.data.id);
                        ReactSession.set("UserfirstName", res.data.data.firstName);
                        ReactSession.set("UserLastName", res.data.data.lastName);
                        ReactSession.set("UserPhoneNumber", res.data.data.phoneNumber);
                        ReactSession.set("UserType", res.data.data.type);
                        ReactSession.set("UserEmail", res.data.data.email);
                        setTimeout(() => {
                            if (res.data.data.type == "normalUser") {
                                window.location.href = "./normal";
                            } else if (res.data.data.type == "producerUser") {
                                window.location.href = "./producer";
                            }
                        }, 2000);
                    })
                    .catch((error) => {
                        // console.log(error);
                        loginDialogPassOk.style.display = "none";
                        loginDialogPassErr.style.display = "inline-block";
                        if (error.response.data.message) {
                            loginDialogPassErr.textContent = error.response.data.message;
                        } else {
                            loginDialogPassErr.textContent = "کد وارد شده اشتباه است";
                        }
                    });
            } else {
                loginDialogPassErr.style.display = "inline-block";
                loginDialogPassErr.textContent = " شماره تلفن و رمز خود را وارد نمایید";
            }
        }
    };
    const sendRegCode = () => {
        if (document.getElementById("regPhone")) {
            var regPhone = document.getElementById("regPhone").value;
            if (regPhone.slice(0, 2) == "98") {
                regPhone = parseInt(regPhone.substring(2));
            }
            console.log(regPhone);

            var regDialogwait = document.getElementById("labelLSGNDialogRegWait");
            var regDialogCodeOk = document.getElementById("labelLSGNDialogRegCodeOk");
            var regDialogErr = document.getElementById("labelLSGNDialogRegErr");

            regDialogwait.style.display = "none";
            regDialogCodeOk.style.display = "none";
            regDialogErr.style.display = "none";

            if (regPhone) {
                axios
                    .get("https://hammaskan.ir:8443/api/auths/reg/code/" + regPhone, {
                        params: {},
                    })
                    .then((res) => {
                        console.log(res);
                        regDialogErr.style.display = "none";
                        regDialogCodeOk.style.display = "inline-block";
                    })
                    .catch((error) => {
                        console.log(error);
                        regDialogCodeOk.style.display = "none";
                        regDialogErr.style.display = "inline-block";
                        if (error.response.data.message) {
                            regDialogErr.textContent = error.response.data.message;
                        } else {
                            regDialogErr.textContent = "امکان ارسال پیامک وجود ندارد";
                        }
                    });
            } else {
                setTimeout(() => {
                    regDialogCodeOk.style.display = "none";
                    regDialogErr.style.display = "inline-block";
                    regDialogErr.textContent = "شماره تلفن خود را وارد نمایید";
                }, 300);
            }
        }
    };
    const RegCode = () => {
        console.log("ok");
        if (document.getElementById("regPhone")) {
            var regDialogwait = document.getElementById("labelLSGNDialogRegWait");
            var regDialogCodeOk = document.getElementById("labelLSGNDialogRegCodeOk");
            var regDialogErr = document.getElementById("labelLSGNDialogRegErr");

            regDialogwait.style.display = "none";
            regDialogCodeOk.style.display = "none";
            regDialogErr.style.display = "none";

            var regFirstname = document.getElementById("regFirstname").value;
            var regLastname = document.getElementById("regLastname").value;
            var regEmail = document.getElementById("regEmail").value;
            var regPhone = document.getElementById("regPhone").value;
            var regCode = document.getElementById("regCode").value;
            var regPassword = document.getElementById("regPassword").value;
            var regRePassword = document.getElementById("regRePassword").value;

            if (regFirstname && regLastname && regPhone && regCode && regPhone && regPassword && regRePassword) {
                if (regPassword == regRePassword) {
                    axios
                        .post("https://hammaskan.ir:8443/api/users", {
                            firstName: regFirstname,
                            lastName: regLastname,
                            email: regEmail,
                            phoneNumber: regPhone,
                            password: regPassword,
                            rePassword: regRePassword,
                            regCode: regCode,
                        })
                        .then((res) => {
                            regDialogwait.style.display = "inline-block";
                            regDialogCodeOk.style.display = "none";
                            regDialogErr.style.display = "none";
                            console.log(res);
                            ReactSession.set("UserId", res.data.data.id);
                            ReactSession.set("UserfirstName", res.data.data.firstName);
                            ReactSession.set("UserLastName", res.data.data.lastName);
                            ReactSession.set("UserPhoneNumber", res.data.data.phoneNumber);
                            ReactSession.set("UserType", res.data.data.type);
                            ReactSession.set("UserEmail", res.data.data.email);
                            setTimeout(() => {
                                if (res.data.data.type == "normalUser") {
                                    window.location.href = "./normal";
                                }
                            }, 2000);
                        })
                        .catch((error) => {
                            // console.log(error);
                            regDialogwait.style.display = "none";
                            regDialogCodeOk.style.display = "none";
                            regDialogErr.style.display = "inline-block";
                            if (error.response.data.message) {
                                regDialogErr.textContent = error.response.data.message;
                            } else {
                                regDialogErr.textContent = "اطلاعات وارد شده صحیح نمی باشد";
                            }
                        });
                } else {
                    setTimeout(() => {
                        regDialogwait.style.display = "none";
                        regDialogCodeOk.style.display = "none";
                        regDialogErr.style.display = "inline-block";
                        regDialogErr.textContent = "لطفا پسورد خود را یکسان وارد نمایید";
                    }, 300);
                }
            } else {
                setTimeout(() => {
                    regDialogwait.style.display = "none";
                    regDialogCodeOk.style.display = "none";
                    regDialogErr.style.display = "inline-block";
                    regDialogErr.textContent = "لطفا اطلاعات خود را کامل وارد نمایید";
                }, 300);
            }
        }
    };

    return (
        <div className="loginSignUp">
            <div className="UpDiveLoginSignUp">
                <div className="containerCrangeBoxLSGN">
                    <div className="orangeBoxLSGN">
                        <div className="middleDivOrangeBox">
                            <div className="buttonsDivOrangeBoxLSGN">
                                <div
                                    style={{ marginBottom: "0" }}
                                    onClick={() => {
                                        setSwitch(20);
                                    }}
                                    className={["SignUpBTNSwitch", switchs === 20 ? "btnActiveSNGL" : ""].join(" ")}
                                >
                                    ثبت نام
                                </div>
                            </div>
                            <div className="lineBetweenOrangeBoxLSGN"></div>
                            <div className="buttonsDivOrangeBoxLSGN">
                                <div
                                    style={{ marginBottom: "15px" }}
                                    onClick={() => {
                                        setSwitch(10);
                                    }}
                                    className={["SignUpBTNSwitch", switchs === 10 || switchs === 11 ? "btnActiveSNGL" : ""].join(" ")}
                                >
                                    ورود ( با شماره تلفن )
                                </div>
                                <div
                                    onClick={() => {
                                        setSwitch(12);
                                    }}
                                    className={["SignUpBTNSwitch", " marginCancelationLSNGBTN", switchs === 12 ? "btnActiveSNGL" : ""].join(" ")}
                                >
                                    ورود ( با رمزعبور )
                                </div>
                            </div>
                            {/* <div className="LogInWithGoogleLSGN">
                                <div className="googleIconLSGN">
                                    <FcGoogle />
                                </div>
                                ورود با اکانت Gmail
                            </div> */}
                            <div className="BahamIcon">
                                <img alt="" />
                            </div>
                            <div className="BahamBrandLSGN">
                                <span>ب</span>رنامه <span>ا</span>نتخاب <span>ه</span>وشمند <span>م</span>سکن
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
            <div className="backDivLoginSignUp">
                <div></div>
                <div className="containerBackContentLSGN">
                    <div className="headerComponentLoginSignUp">
                        <div>
                            <h1>
                                به <span>باهم</span> خوش آمدید
                            </h1>
                        </div>
                        <div>شما میتوانید با ثبت نام از تمامی قابلیت های سایت باهم نهایت استفاده داشته باشید</div>
                    </div>
                </div>
            </div>
            <div className="backDivLoginSignUp greyBackGroundBackDivLSGN">
                <div></div>
                <div className="containerBackContentLSGN">
                    <div className="contentComponentLoginSignUp">
                        {switchs === 10 ? (
                            <div className="loginSectionLSGN">
                                <div className="codeTaeedBox">
                                    <div className="labelLSGN">
                                        <span>شماره تلفن همراه</span>
                                        <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </div>
                                    <div className="inputLSGN">
                                        <input id="loginPhone" type="text" />
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        کد تایید به شماره تلفن همراه شما ارسال شد
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        --
                                    </div>
                                </div>
                                <div className="btnRowLogin">
                                    <div className="btnLSGN" onClick={sendLoginCode} style={{ cursor: "pointer", zIndex: "100" }}>
                                        دریافت کد ورود
                                    </div>
                                    <div className="labelLSGN labelLSGN2 taeedCodeLabel">
                                        <span>با ورود به باهم ، قوانین و مقررات باهم را می پذیرم</span>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {switchs === 11 ? (
                            <div className="loginSectionLSGN">
                                <div className="codeTaeedBox">
                                    <div className="labelLSGN taeedCodeLabel">
                                        <span>کد تایید</span>
                                        <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </div>
                                    <div className="inputLSGN taeedcodeInput">
                                        <input id="loginCode" type="text" />
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogText" style={{ display: "inline-block", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        لطفا کد تایید ارسالی به شماره تلفن خود را وارد نمایید
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        لطفا کمی صبر کنید ...
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        --
                                    </div>
                                </div>
                                <div className="btnRowLogin">
                                    <div className="btnLSGN" style={{ cursor: "pointer", zIndex: "100" }} onClick={LoginCode}>
                                        ورود
                                    </div>
                                    <div className="labelLSGN labelLSGN2 taeedCodeLabel">
                                        <span>با ورود به باهم ، قوانین و مقررات باهم را می پذیرم</span>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {switchs === 12 ? (
                            <div className="loginSectionLSGN">
                                <div className="codeTaeedBox">
                                    <div className="labelLSGN">
                                        <span>شماره تلفن همراه</span>
                                        <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </div>
                                    <div className="labelLSGN"></div>
                                    <div className="inputLSGN">
                                        <input id="loginPassPhone" type="text" />
                                    </div>
                                    <div className="labelLSGN">
                                        <span>
                                            رمز عبور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                        </span>
                                    </div>
                                    <div className="inputLSGN">
                                        <input id="loginPassword" type="password" required />
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogPassOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        لطفا کمی صبر کنید ...
                                    </div>
                                    <div className="labelLSGN" id="labelLSGNDialogPassErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                        --
                                    </div>
                                </div>
                                <div className="btnRowLogin">
                                    <div className="btnLSGN" onClick={LoginPass} style={{ cursor: "pointer", zIndex: "100" }}>
                                        ورود
                                    </div>
                                    <div className="labelLSGN labelLSGN2 taeedCodeLabel">
                                        <span>با ورود به باهم ، قوانین و مقررات باهم را می پذیرم</span>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {switchs === 20 ? (
                            <div className="SignUpSectionLSGN" style={{ position: "relative" }}>
                                <div className="labelLSGN">
                                    <span>
                                        نام <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regFirstname" type="text" required />
                                </div>
                                <div className="labelLSGN">
                                    <span>
                                        نام خانوادگی <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regLastname" type="text" required />
                                </div>
                                <div className="labelLSGN">
                                    <span>آدرس ایمیل</span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regEmail" type="text" />
                                </div>
                                <div className="labelLSGN">
                                    <span>
                                        شماره تلفن <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regPhone" type="text" required />
                                </div>
                                <div className="labelLSGN">
                                    <span>
                                        کد ثبت نام <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regCode" type="text" required />
                                </div>
                                <div className="btnLSGN" style={{ cursor: "pointer", zIndex: "100", fontSize: "12px", padding: "12px 32px" }} onClick={sendRegCode}>
                                    دریافت کد ثبت نام
                                </div>
                                <div className="labelLSGN">
                                    <span>
                                        رمز عبور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regPassword" type="password" required />
                                </div>
                                <div className="labelLSGN">
                                    <span>
                                        تکرار رمز عبور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                                    </span>
                                </div>
                                <div className="inputLSGN">
                                    <input id="regRePassword" type="password" required />
                                </div>
                                {/*  */}
                                <div className="labelLSGN" id="labelLSGNDialogRegWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                    لطفا کمی صبر کنید ...
                                </div>
                                <div className="labelLSGN" id="labelLSGNDialogRegCodeOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                    کد ثبت نام به شماره تلفن شما ارسال شد
                                </div>
                                <div className="labelLSGN" id="labelLSGNDialogRegErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                                    --
                                </div>
                                {/*  */}
                                <div className="btnLSGN" style={{ cursor: "pointer", zIndex: "100" }} onClick={RegCode}>
                                    ورود
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
